import { testimonials } from '@/mocks/home';

export default function TestimonialsSection() {
  return (
    <section className="w-full py-14 md:py-18 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">玩家口碑</h2>
          <p className="text-foreground-600 text-sm md:text-base">来自千万玩家的真实评价</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5 max-w-6xl mx-auto">
          {testimonials.map((item) => (
            <div
              key={item.id}
              className="rounded-xl bg-background-100 border border-background-200/70 p-5 md:p-6"
            >
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-xs ${i < item.rating ? 'ri-star-fill text-accent-500' : 'ri-star-fill text-background-300'}`}
                  ></i>
                ))}
              </div>
              <p className="text-foreground-700 text-sm leading-relaxed mb-4">&ldquo;{item.comment}&rdquo;</p>
              <div className="flex items-center gap-3 pt-3 border-t border-background-200/70">
                <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center text-primary-700 font-semibold text-sm">
                  {item.avatar}
                </div>
                <div>
                  <div className="text-foreground-900 text-sm font-medium">{item.name}</div>
                  <div className="text-foreground-500 text-xs">{item.date}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}